import { useMutation, useQueryClient } from "react-query";
import { request } from "../../../config/helpers/axios-instance";
import { throwIfRequestError } from "../../hooks/request-error";

// PATCH /api/inventory/orders/:id/cancel — cancelOrder(). Cancels the order and every
// line that isn't already fully RECEIVED.
export default function useCancelPurchaseOrder(orderId) {
    const queryClient = useQueryClient();

    return useMutation(
        async (cancelReason) => {
            const result = await request({
                url: `inventory/orders/${orderId}/cancel`,
                method: "PATCH",
                data: { cancelReason },
            });
            throwIfRequestError(result);
            const body = result.data;
            if (!body?.success) throw body;
            return body.data;
        },
        {
            onSuccess: () => {
                queryClient.invalidateQueries(["pharmacy-purchase-order-detail", orderId]);
                queryClient.invalidateQueries(["pharmacy-purchase-orders"]);
            },
        }
    );
}
